import React, { ReactNode } from 'react';
import { Link as GatsbyLink } from 'gatsby';

interface Props {
  children: ReactNode;
  to: string;
  className?: string;
  activeClassName?: string;
  partiallyActive?: boolean;
  onMouseOver?: () => void;
}

// Since DOM elements <a> cannot receive activeClassName
// and partiallyActive, destructure the prop here and
// pass it only to GatsbyLink
const Link = ({
  children,
  to,
  activeClassName,
  partiallyActive,
  ...other
}: Props) => {
  /*
    The following regex does the following:
      1. Matches if the url starts with `/pages/`
      2. Matches if the url starts with `http://www.lucidchart.com/pages` or `https://www.lucidchart.com/pages/` or `www.lucidchart.com/pages/` or `http://lucidchart.com/pages/` or `https://lucidchart.com/pages/`
      3. Matches if the url starts with `/` but doesn't start with `/blog` and `/documents` and `/users` and `/es/users/`
  */
  const internalRegex = /^(?:\/pages\/|^\/$|(?:https?:\/\/)?(?:www\.)?lucidchart\.com\/?(?:\/pages\/|$)|\/(?!documents|(?:..\/|..-..\/)?users?|blog))(.*)/;
  const internal = to.match(internalRegex);

  // Use Gatsby Link for internal links, and <a> for others
  if (internal) {
    return (
      <GatsbyLink
        to={`/${internal[1]}`}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        data-is-gatsby
        {...other}
      >
        {children}
      </GatsbyLink>
    );
  }
  return (
    <a href={to} {...other}>
      {children}
    </a>
  );
};

export default Link;
